<template>
  <div class="home-welfare-section">
    <div class="home-title">福利专区</div>
    <van-swipe :loop="false"  class="welfare-swiper" :width="renderWidth(8.4)" :show-indicators="false" ref="swiper">
      <van-swipe-item 
        class="item" :class="`caseId-${item.caseId}`" v-for="item in welfareShowList " :key="item.imgUrl"
        :data-sensors-exposure-property-caseId="item.caseId"
        data-sensors-exposure-event-name="Element_Exposure"
        data-sensors-click
        @click="$emit('on-redirect',{url:item.jumpUrl})"
      ><img :src="item.imgUrl" :alt="item.desc" ></van-swipe-item>
      <van-swipe-item class="item" ><img src="./more.png" ></van-swipe-item>
    </van-swipe>
  </div>
</template>

<script>
import { Swipe, SwipeItem } from 'vant'

export default {
  name: 'WelfareSection',
  props: {
    welfareShowList: {
      type: Array,
      default: () => ([])
    }
  },
  components: {
    'van-swipe': Swipe,
    'van-swipe-item': SwipeItem
  },
  mounted () {
    this.$nextTick(() => {
      this.$refs.swiper.resize()
    })
  },
 
  methods: {
    renderWidth (w) {
      return window.rem2px(w)
    }
  }
}
</script>

<style lang="less">
@import "../../../../assets/less/mixin.less";

.home-welfare-section {
  width: 100%;
  overflow: hidden;
  padding-left: 40px;
  .home-title {
    font-size: 38px;
    font-family: PingFangSC-Medium, PingFang SC;
    font-weight: 500;
    color: #333333;
    margin-top: 60px;

  }
  .van-swipe {
    overflow: initial;
  }
  .welfare-swiper {
    margin-top: 20px;
    height: 440px;
    width: 710px;
    box-sizing: content-box;
  }

  .item {
    img {
      width: 600px;
      height: 440px;
      object-fit: contain;
    }
    // margin-right: 20px;
    // width: 620px !important;
  }
}
</style>
